const Chart = require('chart.js')

module.exports = {
	config: {
		chartProperties: {
			type: 'doughnut',
			data: [],
			options: {
				legend: {
					display: false
				},
				tooltips: {
					enabled: false
				},
				hover: {
					animationDuration: 0 // duration of animations when hovering an item
				},
				cutoutPercentage: 50,
				aspectRatio: 1,
				layout: {
					padding: {
						left: 0,
						right: 0,
						top: 0,
						bottom: 0
					}
				}
			}
		},
	},

	model: {
		chartProperties: {},
	},

	methods: {

		initChart: function(){
			if(!this.model.chart && this.$.length > 0){
				this.model.chart = new Chart(this.$.find('> .chartContent > .canvasContainer > canvas'), this.model.chartProperties)
			}
		},

		update(stats){
			this.initChart()

			if(this.model.chart && stats){
				this.model.isEmpty = false

				this.model.chart.data.datasets[0].data = [
					stats.new,
					stats.outDated,
					stats.positive,
					stats.negative,
				]

				this.$.removeClass('isEmpty')
				this.model.chart.update()
			} else {
				this.$.addClass('isEmpty')
				this.model.isEmpty = true
			}
		},
	},

	hooks: {
		attach: function($element, options){
			// in case of refreshes the chart-dom-binding has to be renewed
			if (this.model.chart && (options || {}).refresh){
				this.model.chart.destroy()
				delete this.model.chart
			}
			if(!this.model.chart){
				this.model.chartProperties = this.config.chartProperties
				this.model.chartProperties.data = {
					datasets: [
						{
							data: [],
							backgroundColor: [
								'#0C789E',
								'#D97519',
								'#007700',
								'#B20000',
							],
							hoverBackgroundColor: [
								'#0C789E',
								'#D97519',
								'#007700',
								'#B20000',
							],
							borderColor: [
								'#FCFCFC',
								'#FCFCFC',
								'#FCFCFC',
								'#FCFCFC',
							],
							categoryPercentage: 1,
							barPercentage: 1,
						},
					]
				}
				this.initChart()
			}

			// update immediately in case of inner propertiesForm usage.
			if(this.model.stats){
				this.update(this.model.stats)
			}
		},
	}
}
